export default "__VITE_ASSET__C76L4CvE__"